
export default Object.freeze({
    ADMINISTRATOR: {
        value: 'administrator',
    },
    FINANCIAL_ADMINISTRATOR: {
        value: 'financialAdministrator',
    },
    MANAGER: {
        value: 'manager',
    },
    LABORATORY_MANAGER: {
        value: 'laboratoryManager',
    },
    LABORATORY_MICROBIOLOGIST: {
        value: 'laboratoryMicrobiologist',
    },
    LABORATORY_CHEMIST: {
        value: 'laboratoryChemist',
    },
    SALES_REPRESENTATIVE: {
        value: 'salesRepresentative',
    },
    SALES_MANAGER: {
        value: 'salesManager',
    },
    LABORATORY_TECHNICIAN: {
        value: 'laboratoryTechnician',
    },
    SERVICE_TECHNICIAN: {
        value: 'serviceTechnician',
    },
    ROLE_OPERATOR: {
        value: 'operator',
    },
});
